import React from 'react';
import mountReactApp from 'mount-react-app';
import {routes, reducers} from 'hotels-dweb';
import {getter} from '../common/client-side-storage/src/client-side-storage.web'

import {
  compareDate,
  addDays,
  defaultCheckoutOffset,
  defaultCheckinOffset,
} from '../verticals/hotels-dweb/src/shared/utils/date-utils';

function renderApp() {
  const initialState = window.__initial_state__;
  initialState.common.checkin.date = new Date(initialState.common.checkin.date);
  initialState.common.checkout.date = new Date(initialState.common.checkout.date);

  if (compareDate(initialState.common.checkin.date, new Date(), (a, b) => a < b)) {
    initialState.common.checkin.date = addDays(new Date(), defaultCheckinOffset);
  }

  if (compareDate(initialState.common.checkout.date, new Date(), (a, b) => a < b)) {
    initialState.common.checkin.date = addDays(new Date(), defaultCheckoutOffset);
  }
  const mmtAuthObject = getter('myPartnerAuth');
  if(mmtAuthObject && mmtAuthObject.mmt_auth) {
    initialState.myaccount.authToken = mmtAuthObject.mmt_auth;
  } 

  mountReactApp({
    routes,
    reducers,
    initialState,
  });
}

renderApp();

if (module.hot) {
  module.hot.accept('hotels-dweb', () => renderApp());
}
